<template>
  <div class="videobox">
    <div class="video-true">
      <div class="video-l">
        <video style="width: 100%; height: 100%" ref="video" controls></video>
      </div>
      <div class="video-r">
        <div class="video-rt">
          <span>{{ this.damName }}·实时视频</span>
          <span>{{ this.cityName }}</span>
        </div>
        <div class="video-rc">
          <div
           class="control"
           @mouseover="videoHover = 1"
           @mouseleave="videoHover = 0"
          >
            <div>
              <div></div>
              <div
               @mouseover="directionHover.top = true"
               @mouseleave="directionHover.top = false"
               @click="videoControlClick('UP')"
               style="cursor: pointer"
              >
                <img
                 :src="
                    directionHover.top === true
                      ? require(`./imgs/top1.png`)
                      : require(`./imgs/top.png`)
                  "
                 alt
                />
              </div>
              <div></div>
            </div>
            <div>
              <div
               @mouseover="directionHover.left = true"
               @mouseleave="directionHover.left = false"
               @click="videoControlClick('LEFT')"
               style="cursor: pointer"
              >
                <img
                 :src="
                    directionHover.left == true
                      ? require(`./imgs/left1.png`)
                      : require(`./imgs/left.png`)
                  "
                 alt
                />
              </div>
              <div>
                <img
                 :src="
                    directionHover.center == true
                      ? require(`./imgs/center1.png`)
                      : require(`./imgs/center.png`)
                  "
                 alt
                />
              </div>
              <div
               @mouseover="directionHover.right = true"
               @mouseleave="directionHover.right = false"
               @click="videoControlClick('RIGHT')"
               style="cursor: pointer"
              >
                <img
                 :src="
                    directionHover.right == true
                      ? require(`./imgs/right1.png`)
                      : require(`./imgs/right.png`)
                  "
                 alt
                />
              </div>
            </div>
            <div>
              <div></div>
              <div
               @mouseover="directionHover.bottom = true"
               @mouseleave="directionHover.bottom = false"
               @click="videoControlClick('DOWN')"
               style="cursor: pointer"
              >
                <img
                 :src="
                    directionHover.bottom == true
                      ? require(`./imgs/bottom1.png`)
                      : require(`./imgs/bottom.png`)
                  "
                 alt
                />
              </div>
              <div></div>
            </div>
            <div class="video-hover" v-show="videoHover == 1">
              <p>
                上下左右方向用于控制监控视角的调整，中间的圆形用于控制监控器的暂停和视角转动
              </p>
            </div>
          </div>
        </div>
        <div class="video-rb">
          <div class="yzdBtnDiv" v-if="yzdList.length > 0">
            <button
             v-for="item in yzdList"
             :key="item.presetPointIndex"
             @click="moveToPresets(item.presetPointIndex)"
            >
              {{ item.presetPointName }}
            </button>
          </div>
          <!-- <div class="yzdBtnDiv" v-if="videosList.length > 0">
            <button
              v-for="(item, index) in videosList"
              :key="index + 1"
              @click="changeVideoDeviceId(item)"
              :disabled="videoDeviceId == item"
            >
              视频{{ index + 1 }}
            </button>
          </div> -->
          <button class="video-btn" @click="closeVideo">关闭视频</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import flvjs from 'flv.js/dist/flv'
import Hls from 'hls.js'

export default {
  name: 'MapVideoBox',
  props: ['videoInfo', 'yzdList'],
  data () {
    return {
      videoHover: 0, // 控制video控制按钮的hover的效果
      damName: '',
      cityName: '',
      flvPlayer: null,
      videoDeviceId: '',
      hls: null,
      directionHover: {
        top: false,
        right: false,
        bottom: false,
        left: false,
        center: false
      },
      videosList: [],
      headers: {
        'Access-Token': this.$store.state.token
      }
    }
  },
  mounted () {
    // console.log("this.videoInfo----", this.videoInfo)
    if (this.videoInfo) {
      this.damName = this.videoInfo.ydbmc
      this.cityName = this.videoInfo.address
      this.videoDeviceId = this.videoInfo.videoDeviceId
      if (this.videoInfo.url && this.videoInfo.url.indexOf('m3u8') != -1) {
        this.hlsVideoOpen()
      }
      if (this.videoInfo.url && this.videoInfo.url.indexOf('flv') != -1) {
        this.renderVideo()
      }
    }
  },
  methods: {
    moveToPresets (index) {
      let data = {
        id: this.videoInfo.id,
        presetIndex: index,
        type: '1'
      }
      Axios.post('/hzyApi/hwDocking/moveToPresets', data, {
        params: data,
        headers: this.headers
      }).then((res) => {
      })
    },
    videoControlClick (order) {
      const params = new URLSearchParams()
      params.append('action', order != 'STOP' ? 0 : 1)
      params.append('command', order)
      params.append('cameraIndexCode', this.videoDeviceId)
      Axios.post('/hzyApi/hwDocking/controlling', params, {
        data: params,
        headers: this.headers
      }).then((res) => {
        if (res.data.code == 200) {
          console.log('调整成功')
        }
      })
      // 一秒后停止
      setTimeout(() => {
        const paramsT = new URLSearchParams()
        paramsT.append('action', 1)
        paramsT.append('command', order != 'STOP' ? order : '')
        paramsT.append('cameraIndexCode', this.videoDeviceId)
        Axios.post('/hzyApi/hwDocking/controlling', paramsT, {
          data: paramsT,
          headers: this.headers
        }).then((res) => {
          if (res.data.code == 200) {
            console.log('调整成功')
          }
        })
      }, 1000)
    },
    renderVideo () {
      // console.log(url, damName, "视频的信息");
      let videoElement = this.$refs.video
      if (this.videoInfo.url && this.videoInfo.url.length > 0) {
        if (flvjs.isSupported()) {
          this.flvPlayer = flvjs.createPlayer({
            type: 'flv',
            url: this.videoInfo.url
          })
          this.flvPlayer.attachMediaElement(videoElement)
          this.flvPlayer.load()
          this.flvPlayer.play()
        }
      }
    },
    closeVideo () {
      if (this.flvPlayer) {
        this.flvPlayer.pause()
        this.flvPlayer.unload()
        this.flvPlayer.detachMediaElement()
        this.flvPlayer.destroy()
        this.flvPlayer = null
      }
      if (this.hls) {
        this.hls.destroy()
        this.hls = null
      }
      this.$emit('closeVideoClick')
    },
    hlsVideoOpen () {
      let video = this.$refs.video
      if (this.videoInfo.url && this.videoInfo.url.length > 0) {
        if (Hls.isSupported()) {
          this.hls = new Hls()
          this.hls.loadSource(this.videoInfo.url)
          this.hls.attachMedia(video)
          this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            console.log('加载成功！')
            video.play()
          })
          this.hls.on(Hls.Events.ERROR, (event, data) => {
            console.log('加载失败', data)
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.videobox {
  position: absolute;
  top: 20%;
  left: 20%;
  width: 60vw;
  height: 60vh;
  z-index: 25;
  background-color: rgba(0, 1, 32, 0.6) !important;
  border: 2px dashed aquamarine;

  .video-true {
    width: 100%;
    height: 100%;
    display: flex;

    .video-l {
      width: 75%;
      height: 100%;
      padding-left: 15px;
    }

    .video-r {
      width: 25%;
      height: 100%;

      .video-rt {
        width: 100%;
        height: 20%;
        color: #fff;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        gap: 15px;

        & > span:nth-child(1) {
          font-size: 1.5rem;
          font-weight: bold;
        }

        & > span:nth-child(2) {
          font-size: 0.9rem;
        }
      }

      .video-rc {
        width: 100%;
        height: 50%;

        background-size: 90;
        display: flex;
        justify-content: center;
        align-items: center;

        .control {
          width: 200px;
          height: 200px;
          position: relative;
          background: url(./imgs/circle.png) no-repeat;

          & > div {
            width: 100%;
            height: 33.3%;
            display: flex;

            & > div {
              width: 33.3%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .video-hover {
            position: absolute;
            bottom: -38%;
            width: 200px;
            height: 70px;
            background-color: #fff;
            padding: 5px;
            font-size: 0.8rem;
            border-radius: 5px;
            color: #000f1e;
          }
        }
      }

      .video-rb {
        width: 100%;
        height: 30%;
        display: flex;
        flex-direction: column;

        .yzdBtnDiv {
          width: 100%;
          height: auto;
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-wrap: wrap;

          button {
            width: 27%;
            padding: 7px 10px;
            margin-bottom: 10px;
            border-radius: 5px;
            border: none;
            font-family: "YSBTH";
            font-size: 1rem;
            cursor: pointer;
          }
        }

        .video-btn {
          width: 80%;
          padding: 7px 30px;
          border-radius: 5px;
          border: none;
          font-family: "YSBTH";
          font-size: 1.2rem;
          margin: 1vh 0 0 2vh;
        }
      }
    }
  }

  .video-false {
    width: 100%;
    height: 100%;
    display: flex;
    gap: 100px;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    font-size: 3rem;
    color: #fff;
    font-weight: bold;

    // font-family: "YSBTH";
    .video-btn {
      padding: 7px 30px;
      border-radius: 5px;
      border: none;
      font-family: "YSBTH";
      font-size: 1.2rem;
    }
  }
}
</style>
